export const NodeHotKey = ({ type, key }) => ({
  // eslint-disable-next-line
  onKeyDown(event, editor, next) {
    const modKeyPressed = event.metaKey || event.ctrlKey;
    if (!modKeyPressed || event.key !== key) {
      return next();
    }
    event.preventDefault();
    const isType = editor.value.blocks.some(block => block.type === type);
    editor.setBlock(isType ? 'paragraph' : type);
  },
});
